import React from 'react'

interface ModelTypeBadgeProps {
  modelType: 'OD' | 'PR' | 'PC'
}

export const ModelTypeBadge: React.FC<ModelTypeBadgeProps> = ({ modelType }) => {
  return <span className="eval-model-type-badge" data-model-type={modelType}>{modelType}</span>
}
